module.exports = __webpack_public_path__ + "img/07.a3eaa1ab.jpg";